"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyoElement = void 0;
const StringTools_1 = require("./StringTools");
function trm(source) {
    return StringTools_1.trimToSize(source, 8);
}
class MyoElement {
    constructor(cloud, elementData) {
        this.cloud = cloud;
        this.updateFrom(elementData);
    }
    updateFrom(elementData) {
        Object.assign(this, elementData);
        // normalize undefineds from nulls:
        if (this.uniqueTag === null)
            this.uniqueTag = undefined;
        if (this.tag1 === null)
            this.tag1 = undefined;
        if (this.tag2 === null)
            this.tag2 = undefined;
        if (this.tag3 === null)
            this.tag3 = undefined;
    }
    toString() {
        return `E[${this.id}/${this.serial}:${trm(this.uniqueTag)}:${trm(this.tag1)}:${trm(this.tag2)}:${trm(this.tag3)}` +
            `|${this.revision},h=${this.head.length}b]`;
    }
}
exports.MyoElement = MyoElement;
//# sourceMappingURL=MyoElement.js.map